export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="relative border-t border-border/50">
      <div className="px-6 md:px-12 lg:px-20 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 md:gap-16">
            <div className="flex items-center gap-4">
              <img
                src="https://storage.helloreaddy.io/project_files/67d84fd7-5259-43f2-8b88-812a2bb89269/8312ae00-1c0f-47a3-b040-18487b03ab08_compressed_LOB_logo_white_transparent.webp"
                alt="株式会社LoB"
                className="h-8 md:h-10 w-auto"
              />
              <div>
                <p className="text-sm md:text-base font-bold text-white">
                  株式会社LoB
                </p>
                <p className="text-xs text-text-muted">LoB Co., Ltd.</p>
              </div>
            </div>

            <nav className="grid grid-cols-2 md:flex md:items-start gap-x-8 gap-y-4 md:gap-10">
              <a
                href="#about"
                onClick={(e) => handleNavClick(e, "#about")}
                className="text-xs tracking-[0.15em] text-text-secondary hover:text-accent transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                ABOUT
              </a>
              <a
                href="#services"
                onClick={(e) => handleNavClick(e, "#services")}
                className="text-xs tracking-[0.15em] text-text-secondary hover:text-accent transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                SERVICE
              </a>
              <a
                href="#strengths"
                onClick={(e) => handleNavClick(e, "#strengths")}
                className="text-xs tracking-[0.15em] text-text-secondary hover:text-accent transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                STRENGTH
              </a>
              <a
                href="#company"
                onClick={(e) => handleNavClick(e, "#company")}
                className="text-xs tracking-[0.15em] text-text-secondary hover:text-accent transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                COMPANY
              </a>
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, "#contact")}
                className="text-xs tracking-[0.15em] text-text-secondary hover:text-accent transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                CONTACT
              </a>
            </nav>
          </div>
        </div>
      </div>

      <div className="border-t border-border/30 px-6 md:px-12 lg:px-20 py-6 md:py-8">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-text-muted">
            © 2026 LoB Co., Ltd. All Rights Reserved.
          </p>
          <p className="text-xs text-text-muted">株式会社LoB</p>
        </div>
      </div>
    </footer>
  );
}